import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
@Injectable()
export class SearchPipe implements PipeTransform {
  // SearchPipe
  // Filter user search results for name or username excluding the excludedIds.
  transform(accounts: any[], data: [[any], any]): any {
    let excludedIds = data[0];
    var term: string = data[1];
    if (!accounts) {
      console.log("0");
      return;
    } else if (!excludedIds) {
      console.log("!!1");
      return accounts;
    } else if (excludedIds && !term) {
      console.log("!!2");
      return accounts.filter((account) => excludedIds.indexOf(account.userId) == -1);
    } else {
      if(term)term = term.toLowerCase();
      return accounts.filter((account) => excludedIds.indexOf(account.userId) == -1 && (account.name && account.name.toLowerCase().indexOf(term) > -1 || account.username && account.username.toLowerCase().indexOf(term) > -1));
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/search.ts